var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00049 4.42773V7.48964",
    stroke: "#EB9700",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00031 11.0619C8.28215 11.0619 8.51063 10.8334 8.51063 10.5516C8.51063 10.2697 8.28215 10.0413 8.00031 10.0413C7.71847 10.0413 7.48999 10.2697 7.48999 10.5516C7.48999 10.8334 7.71847 11.0619 8.00031 11.0619Z",
    stroke: "#EB9700",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22771 1.68513L1.68506 7.22778C1.25858 7.65427 1.25858 8.34573 1.68506 8.77222L7.22771 14.3149C7.65419 14.7413 8.34566 14.7413 8.77214 14.3149L14.3148 8.77222C14.7413 8.34573 14.7413 7.65427 14.3148 7.22778L8.77214 1.68513C8.34566 1.25865 7.65419 1.25865 7.22771 1.68513Z",
    stroke: "#EB9700",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingAlertIcon);
export default __webpack_public_path__ + "static/media/pending-alert-icon.93db01a3c98ad3de6132714c607b2a2e.svg";
export { ForwardRef as ReactComponent };